import Article from "@/src/components/journal-site/common/article/article";
import ArticleList from "@/src/_types/Article/article-list";
import ArticleDiscovery from "@/src/components/journal-site/articles/article-similar-articles/article-discovery";
import SectionHeading from "@/src/components/common/broadsheet/section-heading";
import { hairlineTop } from "@/src/components/common/broadsheet/tokens";
import { Box } from "@mui/material";

const toAuthor = (fullName: string): Author => {
  const parts = fullName.trim().split(/\s+/);

  return {
    id: "",
    correspond: false,
    correspondence_id: "",
    correspondence_label: "",
    deceased: "",
    equal_contrib: "no",
    first_name: parts.slice(0, -1).join(" "),
    last_name: parts[parts.length - 1] ?? "",
    orcid: null,
  };
};

const toArticleListItem = (article: ArticleCardData): ArticleList => ({
  id: 0,
  display_order: 0,
  title: article.title,
  pub_dates: { epub: article.epub },
  feature_image_thumbnail: article.feature_image_thumbnail ?? [],
  issue_featured_image: null,
  document_type: "",
  href: article.url,
  authors: article.authors.map(toAuthor),
  pdf_file: `${article.url}.pdf`,
  proof_status: "",
  desired_issue_id: 0,
  desired_issue: null,
  issue_id: 0,
  doi: article.doi,
  has_altmetric: false,
  publon_badge: false,
  how_to_cite: article.how_to_cite,
});

const ArticleSimilarArticles = ({
  similarArticles,
  authors = [],
  articleTitle = "",
}: {
  similarArticles: ArticleCardData[];
  authors?: Author[];
  articleTitle?: string;
}) => {
  const hasSimilar = similarArticles && similarArticles.length > 0;
  const hasDiscovery = (authors?.length ?? 0) > 0 || !!articleTitle;

  if (!hasSimilar && !hasDiscovery) return null;

  return (
    <Box component="section" sx={{ mt: 1.25, pt: 1, ...hairlineTop }}>
      <SectionHeading
        title={hasSimilar ? "Similar Articles" : "Related work"}
        component="h2"
        rule={false}
      />
      {hasSimilar
        ? similarArticles.map((similarArticle: ArticleCardData) => (
            <Box key={similarArticle.url} sx={{ py: 0.75, ...hairlineTop }}>
              <Article
                article={toArticleListItem(similarArticle)}
                showHowToCite
              />
            </Box>
          ))
        : null}
      <ArticleDiscovery authors={authors} articleTitle={articleTitle} />
    </Box>
  );
};

export default ArticleSimilarArticles;
